import React from 'react';
import { GiftCardBalanceSuccess } from '../../models/giftcard';
import { Button, Link, Text } from '~/shared/components/';
import { GridItem } from '~/features/navigation/components/N60Footer/components/GridItem';
import { StyledGiftCardContainer, StyledGrid } from './styled';
import { AlignContent } from '~/templates/blocks/components/AlignContent/AlignContent';
import { format } from 'date-fns';
import { useTranslation } from '~/shared/utils/translation';
import { useUtils } from '~/shared/hooks/useUtils';

type Props = GiftCardBalanceSuccess & {
    clearState: () => void;
};

export const GiftCardStatus = (props: Props) => {
    const { translate } = useTranslation();
    const { convertPriceToLocale } = useUtils();
    const expDate = props.expirationDate
        ? format(new Date(props.expirationDate), 'dd.MM.yyyy')
        : false;

    return (
        <StyledGiftCardContainer>
            <AlignContent alignment="center" position="center">
                <Text variant="display3">{translate('giftCardBalance.yourSaldo')}</Text>
                <Text variant="displaySaldoNumber" style={{ marginBottom: '30px' }}>
                    {convertPriceToLocale(props.balance)} {translate('common.currency')}
                </Text>
                <StyledGrid flow="column" columns={!expDate ? '1fr' : '1fr auto'}>
                    <GridItem style={{ gap: '8px', textAlign: 'left' }}>
                        <Text variant="bodySmall">{translate('giftCardBalance.giftCard')}</Text>
                        <Text variant="bodySmall">{props.certificateNumber}</Text>
                    </GridItem>
                    {!expDate ? (
                        ''
                    ) : (
                        <GridItem style={{ gap: '8px', textAlign: 'left' }}>
                            <Text variant="bodySmall">
                                {translate('giftCardBalance.giftCardExpirationDate')}
                            </Text>
                            <Text variant="bodySmall">{expDate}</Text>
                        </GridItem>
                    )}
                </StyledGrid>
                <Button as={Link} aria-label="link" variant="primary" href="/" size="large">
                    {translate('giftCardBalance.giftCardBalanceCTALabel')}
                </Button>
            </AlignContent>
        </StyledGiftCardContainer>
    );
};
